import { createContext, useContext } from "react";
import invariant from "tiny-invariant";
import type { BaseFilter } from "../types";

interface FilterValueContextValue {
  filterParams: BaseFilter[];
  onAdd?: (filter: BaseFilter) => void;
  onApply?: (id: string, filter: BaseFilter) => void;
  onClear?: (index: number) => void;
  onClearAll?: () => void;
}

/**
 * This context holds value of a filter and utilities to update it.
 */
export const FilterValueContext = createContext<FilterValueContextValue | null>(
  null,
);

FilterValueContext.displayName = "FilterValueContext";

export const useFilterValueContext = () => {
  const context = useContext(FilterValueContext);

  invariant(
    context,
    "useFilterValueContext must be used within a FilterValueContext",
  );
  return context;
};
